export const styles = {
  card: {
    padding: '1rem 2rem',
    transition: 'all 0.3s ease-in-out',
    width: '100%',
  },
};
